import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useContext, useEffect, useMemo, useState } from 'react';
import { Analytics, useViewport } from '@bpm-web-app/utils';
import { NavContext } from './nav.context';
import styles from './nav.module.css';

// Icons
import { PlainNavItem } from './plain-nav-item';
import { NavFooter } from './nav-footer';
import { artistPortalNavItems } from './nav-menu-items';
import { AppLink } from '../shared';
import CloseNav from '../../assets/icons/close-nav.svg';
import ArtistLogo from '../../assets/icons/artist-platform/yellow-icon.svg';

export function NavArtistPortal() {
    const router = useRouter();

    const { isNavOpen, isNavHidden, openNav, closeNav } = useContext(NavContext);

    useEffect(() => {
        // Analytics.platform = 'artist';
        // Analytics.trackSession('start');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { isMobile } = useViewport();

    const navItems = useMemo(() => artistPortalNavItems(), []);

    /* Close nav (if on mobile) + go back to the first level nav on route change. */
    useEffect(() => {
        const handleRouteChange = () => {
            if (isNavOpen && isMobile) closeNav();
        };

        router.events.on('routeChangeStart', handleRouteChange);

        return () => {
            router.events.off('routeChangeStart', handleRouteChange);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [closeNav, isNavOpen, router.events]);

    useEffect(() => {
        if (isNavOpen && isMobile) {
            document.documentElement.classList.add('stop-scroll');
        } else {
            document.documentElement.classList.remove('stop-scroll');
        }
    }, [isMobile, isNavOpen]);

    const onClickNavItem = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (isNavOpen && isMobile) closeNav();
    };

    useEffect(() => {
        if (isNavOpen && isMobile) closeNav();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMobile]);

    return (
        <nav
            // eslint-disable-next-line @typescript-eslint/dot-notation
            className={classNames(styles['nav'], styles['nav__ap'], {
                [styles['nav--open']]: isNavOpen,
                [styles['nav--hidden']]: isNavHidden,
            }, styles['nav--fullscreen-mobile'])}
        >
            <div
                role="button"
                tabIndex={0}
                className={styles['nav__menu']}
            >
                {!isMobile ? (
                    <div className={styles['nav__header-container']}>
                        <button
                            type="button"
                            className={classNames(styles['nav__close-btn'], styles['nav__menu-item--menu-text-collapse-title'])}
                            onClick={() => {
                                if (isNavOpen) {
                                    closeNav();
                                } else {
                                    openNav();
                                }
                            }}
                        >
                            <div className={styles['nav__logo-container']}>
                                <AppLink href="/">
                                    <i aria-label="Homepage" className={styles['nav__logo-img']}>
                                        <ArtistLogo />
                                    </i>
                                </AppLink>

                                <div className={styles['nav__header-info-container']}>
                                    <h4 className={classNames(styles['nav__header-title'], { [styles['nav__header-title--closed']]: !isNavOpen })}>BPM For Artist</h4>
                                </div>
                                <div className={classNames(styles['nav__menu-item--icon'], styles['nav__menu-item--icon--close'], styles['nav__menu-item--icon--close-artist'])}>{isNavOpen ? <CloseNav /> : null}</div>
                            </div>
                        </button>
                    </div>
                ) : null
                }
                <div className={styles['nav__section-items--divider']} />
                {navItems.map(({ title, icon, activeIcon, path }) => {
                    return (
                        <PlainNavItem
                            key={title}
                            title={title}
                            icon={icon}
                            activeIcon={activeIcon}
                            path={path}
                            onClick={(e) => {
                                Analytics.trackClick('nav_bar', title, { location: 'nav_bar' });
                                if (path !== '/manage-profile') {
                                    onClickNavItem(e);
                                }
                            }} />
                    );
                })}
            </div>
            <NavFooter />
        </nav>
    );
}
